var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.5C18.0034 9.81987 17.6951 11.1219 17.1 12.3C16.3944 13.7117 15.3098 14.8992 13.9674 15.7293C12.6251 16.5594 11.0782 16.9994 9.5 17C8.18013 17.0034 6.87812 16.6951 5.7 16.1L0 18L1.9 12.3C1.30493 11.1219 0.996559 9.81987 1 8.5C1.00061 6.92176 1.44061 5.37485 2.27072 4.03255C3.10083 2.69025 4.28825 1.60557 5.7 0.899998C6.87812 0.304929 8.18013 -0.00344328 9.5 -2.02948e-06H10C12.0843 0.11499 14.053 0.994759 15.5291 2.47086C17.0052 3.94695 17.885 5.91565 18 8V8.5Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.cab6445c4e964229650adb9d3f4be59a.svg";
export { ForwardRef as ReactComponent };